/**
 * ResultCard.jsx
 *
 * Tek bir arama sonucunu kart olarak gösterir.
 * SOLID - Single Responsibility: Sadece bir SearchResultItem'ı render eder.
 *
 * Skor renk skalası:
 *   >= 0.85  → yeşil  (yüksek güven)
 *   0.70-0.85 → sarı  (orta güven)
 *   < 0.70   → kırmızı (düşük güven)
 */

import React from "react";
import EngineBadge from "./EngineBadge";

function getScoreClass(score) {
  if (score >= 0.85) return "score--high";
  if (score >= 0.70) return "score--mid";
  return "score--low";
}

function formatScore(score) {
  const percent = Math.round(score * 1000) / 10; // 0.891234 → 89.1
  return {
    percent: `%${percent.toFixed(1)}`,
    raw: score.toFixed(4),
  };
}

function ResultCard({ result, engine }) {
  const { rank, score, content, document_filename, chunk_index, page_number, source_url } = result;
  const scoreClass = getScoreClass(score);
  const { percent, raw } = formatScore(score);

  return (
    <article
      className="result-card"
      aria-label={`Sonuç ${rank}: ${document_filename}`}
    >
      <div className="result-card__header">
        <span className="result-card__rank" aria-label={`Sıra ${rank}`}>
          #{rank}
        </span>
        <div
          className={`result-card__score ${scoreClass}`}
          title={`Ham skor: ${raw}`}
          aria-label={`Benzerlik skoru: ${percent}`}
        >
          <span className="score__percent">{percent}</span>
          <span className="score__raw">{raw}</span>
        </div>
      </div>

      <p className="result-card__content">{content}</p>

      <footer className="result-card__footer">
        <span className="result-card__source" title={document_filename}>
          <svg className="footer-icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
          </svg>
          {source_url ? (
            <a 
              href={`${source_url}#page=${page_number || 1}`} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: "2px" }}
            >
              {document_filename}
            </a>
          ) : (
            document_filename
          )}
        </span>
        <div className="result-card__footer-right">
          {page_number && (
            <span className="result-card__page" aria-label={`Sayfa: ${page_number}`} style={{ marginRight: '8px' }}>
              Sayfa: {page_number}
            </span>
          )}
          <span className="result-card__chunk" aria-label={`Chunk numarası: ${chunk_index}`}>
            chunk #{chunk_index}
          </span>
          <EngineBadge engine={engine} />
        </div>
      </footer>
    </article>
  );
}

export default ResultCard;
